import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan, faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { decodeHtml } from "../../utils/utils";
import "./metaData.css";

export default function MetaData({
  mainAuthor, setMainAuthor,
  selectedAuthors, setSelectedAuthors,
  authors,
  editor, setEditor,
  editors,
  title, setTitle,
  seoTitle, setSeoTitle,
  metaDescription, setMetaDescription,
  focusKeyphrase, setFocusKeyphrase,
  postSlug, setPostSlug,
  selectedCategories, setSelectedCategories,
  categories,
  tags,
  selectedTags,
  handleTagChange,
  featuredImageData,
  setFeaturedImageData,
  setShowFeatureImageModal,
  toggleTooltip,
  visibleTooltip
}) {

  const customStyles = {
    control: (provided) => ({
      ...provided,
      boxShadow: "none",
      borderRadius: 8,
      border: "1px solid #ccc",
      backgroundColor: "#ffffff",
      color: "#333",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 2, // dropdown appears above other content
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#FFFFFF", // Background color of selected options
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#000000", // Text color of selected options
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#272635", // Color of the dropdown arrow
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#272635", // Color of the separator between the arrow and the input
    }),
  };

  return (
    <>
      <div className="writeFormGroup">
        <label>Author: </label>
        <div className="select author">
          <Select
            options={authors}
            value={mainAuthor}
            onChange={(opt) => setMainAuthor(opt)}
            styles={customStyles}
            placeholder="Select Main Author *"
          />
        </div>
        <div className="writeFieldSpacer"></div>
      </div>
      <div className="writeFormGroup">
        <label>Editor: </label>
        <div className="select author">
          <Select
            options={editors}
            onChange={(selected) => setEditor(selected)}
            value={editor}
            styles={customStyles}
            placeholder="Select Editor"
          />
        </div>
        <div className="writeFieldSpacer"></div>
      </div>
      <div className="optionClass">
        <div className="categories">
          <label>Co-Authors: </label>
          <div className="select">
            <Select
              options={authors.filter(
                (author) => author.value !== mainAuthor?.value
              )}
              isMulti
              value={selectedAuthors}
              onChange={(opts) =>
                setSelectedAuthors(
                  opts.map((opt) => ({
                    label: opt.label,
                    value: decodeHtml(opt.value),
                  }))
                )
              }
              styles={customStyles}
            />
          </div>
          <div className="writeFieldSpacer"></div>
        </div>
      </div>
      <div className="writeFormGroup">
        <label>Title: </label>
        <input
          type="text"
          placeholder="Title *"
          className="writeInput"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <div className="writeFieldSpacer"></div>
      </div>
      <div className="writeFormGroup">
        <label>SEO Title: </label>
        <input
          type="text"
          placeholder="SEO Title *"
          className="writeInput"
          value={seoTitle}
          onChange={(e) => setSeoTitle(e.target.value)}
        />
        <div className="tooltip-container">
          <i className="info-icon" onClick={() => toggleTooltip("seoTitle")}>ℹ️</i>
          {visibleTooltip === "seoTitle" && <div className="tooltip">Start with keyphrase</div>}
        </div>
      </div>
      <div className="writeFormGroup">
        <label>Meta Description: </label>
        <input
          type="text"
          placeholder="Meta Description *"
          className="writeInput"
          value={metaDescription}
          onChange={(e) => setMetaDescription(e.target.value)}
        />
        <div className="tooltip-container">
          <i className="info-icon" onClick={() => toggleTooltip("metaDesc")}>ℹ️</i>
          {visibleTooltip === "metaDesc" && <div className="tooltip">120–156 characters recommended</div>}
        </div>
      </div>
      <div className="writeFormGroup">
        <label>Focus Keyphrase: </label>
        <input
          type="text"
          placeholder="Focus Keyphrase *"
          className="writeInput"
          value={focusKeyphrase}
          onChange={(e) => setFocusKeyphrase(e.target.value)}
        />
        <div className="tooltip-container">
          <i className="info-icon" onClick={() => toggleTooltip("focusKeyphrase")}>ℹ️</i>
          {visibleTooltip === "focusKeyphrase" && <div className="tooltip">3–5 words</div>}
        </div>
      </div>
      <div className="writeFormGroup">
        <label>Slug: </label>
        <input
          type="text"
          placeholder="Slug"
          className="writeInput"
          value={postSlug}
          onChange={(e) => setPostSlug(e.target.value)}
        />
        <div className="tooltip-container">
          <i className="info-icon" onClick={() => toggleTooltip("slug")}>ℹ️</i>
          {visibleTooltip === "slug" && <div className="tooltip">Include keyphrase</div>}
        </div>
      </div>

      <div className="optionClass">
        <div className="categories">
          <label>Categories: </label>
          <div className="select">
            <Select
              options={categories}
              isMulti
              value={selectedCategories}
              onChange={(opts) =>
                setSelectedCategories(
                  opts.map((opt) => ({
                    label: opt.label,
                    value: decodeHtml(opt.value),
                  }))
                )
              }
              styles={customStyles}
              placeholder="Select Categories *"
            />
          </div>
          <div className="writeFieldSpacer"></div>
        </div>
        <div className="tags">
          <label>Tags:</label>
          <div className="select">
            <CreatableSelect
              isMulti
              options={tags}
              value={selectedTags}
              onChange={handleTagChange}
              styles={customStyles}
              placeholder="Select or create tags"
            />
          </div>
          <div className="writeFieldSpacer"></div>
        </div>
      </div>

      <div className="featured-images">
        <label>Featured Image:</label>
        <div
          className="featured-images-container"
          onClick={() => setShowFeatureImageModal(true)}
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && setShowFeatureImageModal(true)}
        >
          {featuredImageData?.src ? (
            <div className="image-wrapper">
              <img
                src={featuredImageData.src}
                alt={featuredImageData.alt || "Featured preview"}
              />
              {featuredImageData.attribution && (
                <p className="image-attribution">Credit: {featuredImageData.attribution}</p>
              )}
              {featuredImageData.caption && (
                <p className="image-caption">Caption: {featuredImageData.caption}</p>
              )}
              <button
                className="remove-image-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setFeaturedImageData(null);
                }}
              >
                ✖️
              </button>
            </div>
          ) : (
            <div className="placeholder">Click to upload featured image</div>
          )}
        </div>
        <div className="tooltip-container">
          <i
            className="info-icon"
            onClick={() => toggleTooltip("featuredImage")}
          >
            ℹ️
          </i>
          {visibleTooltip === "featuredImage" && (
            <div className="tooltip">Visible on the homepage</div>
          )}
        </div>
      </div>
    </>
  );
}
